export default "__VITE_ASSET__I34wLpHi__"